const tableOption = function () {
  return {
    stripe: true,
    page: true,
    maxHeight: "98%",
    align: "center",
    header: false,
    index: true,
    selection: true,
    emptyText: "暂无数据",
    column: [
      {
        label: "交易量(t)",
        prop: "tradeQuantity",
      },
      {
        label: "交易金额",
        prop: "tradeAmount",
      },
      {
        label: "交易平台",
        prop: "tradePlatform",
      },
      {
        label: "交易类型",
        prop: "tradeType",
        search: true,
        clearable: true,
        type: "select",
        dicData: [
          {
            label: '买入',
            value: '1'
          },
          {
            label: '卖出',
            value: '0'
          }
        ],
        formatter: function (row, value) {
          if (Number(value) === 1) {
            return "买入";
          } else if (Number(value) === 0) {
            return "卖出";
          }
          return "";
        }
      },
      {
        label: "交易时间",
        prop: "tradeTime",
      },
      {
        label: "交易人",
        prop: "tradePerson",
      },
      {
        label: "备注",
        prop: "tradeRemark",
      }
    ]
  };
};

export default tableOption;
